/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M256 55C69.818 55 0 256.5 0 256.5S69.818 458 256 458c186.182 0 256-201.5 256-201.5S442.182 55 256 55zm0 50.375c122.818 0 184.91 107.44 205 151.027-20.09 43.29-82.727 151.223-205 151.223-122.818 0-184.91-107.44-205-151.027 20.182-43.29 82.727-151.223 205-151.223zm0 50.375c-51.455 0-93.09 45.062-93.09 100.75S204.544 357.25 256 357.25c51.455 0 93.09-45.062 93.09-100.75S307.456 155.75 256 155.75zm0 50.375c25.727 0 46.545 22.531 46.545 50.375S281.727 306.875 256 306.875s-46.545-22.531-46.545-50.375 20.818-50.375 46.545-50.375z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconEye = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconEye.defaultProps = {
  theme,
};
IconEye.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconEye.displayName = 'IconEye';
export { IconEye };
